import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { EditMailboxPinData } from '../models/edit-mailbox-pin-data';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-edit-mailbox-pin-view',
    styleUrls: ['./edit-mailbox-pin-view.component.scss'],
    templateUrl: './edit-mailbox-pin-view.component.html',
    standalone: false
})
export class EditMailboxPinViewComponent {
   @Input() callState: CallState;

   @Output() formSubmitted = new EventEmitter<EditMailboxPinData>();

   @Output() formCanceled = new EventEmitter<void>();

   @Input() form: UntypedFormGroup;

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.form.markAsPristine();
         this.formSubmitted.emit();
      }
   }
}
